<template>
  <div class="colu colu-12">
    <!-- 總金額 + 剩餘紅利 -->
    <div class="withdraw-detail-frame">
      <div class="detailList">
        <b class="wDtitle">
          <span>{{ $t('Bao.total_amount') }}</span>
        </b>
        <span class="wDamount">
          <template v-if="!isCrypto">{{ currency }} </template>
          <span>{{ displayAmount | numberFormat }}</span>
        </span>
      </div>
      <div class="detailList">
        <b class="wDtitle">{{ $t('Bao.residual_bonus') }}</b>
        <span class="wDamount">{{ currency }} {{ bonusGold | numberFormat }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawSummary',
  props: {
    isCrypto: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: ''
    },
    /** 一般模式：顯示用金額（已格式化前的數值） */
    displayAmount: {
      type: [String, Number],
      default: 0
    },
    bonusGold: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {

  }
}
</script>
